// extracted by mini-css-extract-plugin
module.exports = {"buttonDetalle":"Reviews_buttonDetalle__o1UIh","textarea":"Reviews_textarea__1tFGY","divReviews":"Reviews_divReviews__3QFdT"};